
import { defineComponent } from "vue";
import { Saih } from "@/types/saih.type";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import SaihListComponent from "@/components/saih/SaihList.component.vue";
import SaihFormComponent from "@/components/saih/SaihForm.component.vue";
import { ElMessage } from "element-plus";
import { errorHandlerDefault } from "@/utils/handler.util";

export default defineComponent({
  components: {
    PageButtonsComponent,
    SaihFormComponent,
    SaihListComponent,
  },
  data() {
    return {
      showSaihForm: false,
      saihForm: undefined as undefined | Saih,
    };
  },
  methods: {
    openSaihFormDialog() {
      this.showSaihForm = true;
    },
    closeSaihFormDialog() {
      this.showSaihForm = false;
    },
    async saveSaihForm() {
      await (this.$refs["saihForm"] as InstanceType<typeof SaihFormComponent>)
        .doSave()
        ?.then(() => {
          // - close dialog and refresh
          this.closeSaihFormDialog();
          (this.$refs["saihList"] as InstanceType<typeof SaihListComponent>).refreshItems();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
  },
});
